<div class="image-fullscreen" [class.hide]="isHide">
  <i class="fa fa-times-circle" (click)="close.emit(); isHide = true"></i>
  <img [src]="src">

  <div class="options" *ngIf="isShowBtn">
    <i class="fa fa-chevron-left pointer mr-5" (click)="prev.emit()"></i>
    <i class="fa fa-chevron-right pointer" (click)="next.emit()"></i>
  </div>
</div>
